import { required } from 'vuelidate/lib/validators';
import ToolkitMixin from '@/app/mixins/toolkit/item';
import { assetDiversification } from '@/app/utils/toolkit/business-rules/inv-strat/assetDiversification';

export default {
  name: 'inv-strat-diversification-risk-dialog',
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    risks: {
      type: Array,
      default() {
        return [];
      },
    },
    asset: {
      type: Object,
      required: true,
    },
  },
  mixins: [ToolkitMixin],
  data: () => ({
    riskSelection: [],
    otherRisk: '',
  }),
  computed: {
    filteredRisks() {
      const isLRBA = this.getItem.borrowing;
      // eslint-disable-next-line
      const filteredRisks = this.risks.filter(risk => risk.isLRBA === undefined || isLRBA === risk.isLRBA.toString());
      filteredRisks.forEach((risk) => {
        assetDiversification(risk);
      });
      return filteredRisks;
    },
  },
  watch: {
    riskSelection: {
      handler() {
        if (this.riskSelection.findIndex(el => el === 'other') === -1) {
          this.otherRisk = '';
        }
      },
      immediate: false,
    },
  },
  methods: {
    dismiss() {
      this.$emit('close');
    },
    handleOkClick() {
      const currentAssetRisks = this.riskSelection.map((risk) => {
        if (risk !== 'other') {
          return {
            risk,
            displayValue: this.filteredRisks[risk].displayValue(),
          };
        }
        return {
          risk,
          displayValue: this.otherRisk,
        };
      });

      this.$emit('riskSelections', currentAssetRisks);

      this.dismiss();
    },
    loadRisks() {
      this.riskSelection = this.asset.risks.map(risk => risk.risk);
      const otherRisk = this.asset.risks.find(risk => risk.risk === 'other');
      if (otherRisk) {
        this.otherRisk = otherRisk.displayValue;
      }
    },
  },
  mounted() {
    this.loadRisks();
  },
  validations() {
    if (this.riskSelection.findIndex(value => value === 'other') >= 0) {
      return {
        otherRisk: {
          required,
        },
        riskSelection: {
          required,
        },
      };
    }
    return {
      riskSelection: {
        required,
      },
    };
  },
};
